import { IBreeceSelectorDetails } from "../../../../models/breece-selector-details.interface";

export class BreeceSelectorDetails implements IBreeceSelectorDetails {
  enumName: string;
  value: number | null;
  description: string | null;
  translation: string | null;
  translationCode: string | null;
}